import React from "react";

const WhoWeAre = () => {
  return (
    <div className="bg-white text-black">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 min-h-[70vh]">
          {/* Left Column - Story */}
          <div className="flex items-center p-8 md:p-12 lg:p-20 border-b lg:border-b-0 lg:border-r border-gray-200">
            <div>
              <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-gray-500 mb-6 sm:mb-8">
                Genesis
              </p>
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-thin leading-tight mb-8 sm:mb-12">
                Who
                <br />
                <span className="text-gray-400">We Are</span>
              </h2>

              <div className="space-y-5 sm:space-y-6 md:space-y-8 text-sm sm:text-base md:text-lg font-light leading-relaxed mb-8 sm:mb-12">
                <p>
                  We are an AI training and business transformation company dedicated to empowering
                  professionals and enterprises to leverage the power of AI with confidence.
                </p>

                <p>
                  <span>Founded by practitioners, technologists, and business leaders,</span> we
                  operate at the intersection of technology, strategy, and real-world execution.
                </p>

                <p>
                  Our mission is to ensure individuals and organizations are not passive observers of AI trends, but{" "}
                  <em className="text-gray-500">active participants and leaders</em> using AI to boost productivity,
                  automate workflows, and scale their impact.
                </p>
              </div>
            </div>
          </div>

          {/* Right Column - Expertise */}
          <div className="flex items-center p-8 md:p-12 lg:p-20 bg-gray-50">
            <div>
              <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-gray-500 mb-6 sm:mb-8">
                Expertise
              </p>
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-thin leading-tight mb-8 sm:mb-12">
                Our
                <br />
                <span className="text-gray-400">Focus</span>
              </h2>

              <div className="space-y-5 sm:space-y-6 md:space-y-8 text-sm sm:text-base md:text-lg font-light leading-relaxed mb-8 sm:mb-12">
                <div className="flex items-start gap-4">
                  <div className="w-2 h-2 bg-black rounded-full mt-2.5 flex-shrink-0"></div>
                  <p>
                    <span>Practical AI Training</span> for immediate application and measurable
                    results.
                  </p>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-2 h-2 bg-black rounded-full mt-2.5 flex-shrink-0"></div>
                  <p>
                    <span>Custom AI Solutions</span> tailored to your organization&apos;s
                    culture, workflows, and strategic goals.
                  </p>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-2 h-2 bg-black rounded-full mt-2.5 flex-shrink-0"></div>
                  <p>
                    <span>Enterprise Transformation</span> with sustainable, scalable AI
                    implementation and governance.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhoWeAre;
